import React from 'react';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Modal from 'components/new_ui/Modal/Modal';

import { useNavigate } from 'react-router-dom';

import Actions from './Actions';

export default function UpdateEmail() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const navigate = useNavigate();

  const member = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    email: Yup.string().required('Email is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.updateEmail(
      values,
      () => {
        setSubmitting(false);
        actionsUsers.load(dispatchUsers);
        navigate(-1);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal show>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          email: member.email,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <Row>
              <Col>
                <HorizontalTextField
                  name="email"
                  label="Email"
                  type="email"
                  required
                />
              </Col>
            </Row>

            <Footer loading={isSubmitting} onCancel={() => navigate(-1)} />
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}
